const ERoutes = {
    home: '/',
    dashboard: '/dashboard',
    calendar: '/calendar',
    promoCodes: '/promo-code-management',
    promoCodeList: '/promo-code-management/list',
    promoCodeAdd: '/promo-code-management/add',
    promoCodeEdit: '/promo-code-management/edit/:id',
    brandedAppPromoCodeList: '/branded-app-promo-code/list',
    brandedAppPromoCodeAdd: '/branded-app-promo-code/add',
    brandedAppPromoCodeEdit: '/branded-app-promo-code/edit/:id',
    businessList: '/businesses/list',
    crmBoard: '/crm/board',
    crmJourney: '/crm/journey',
    crmJourneyEnrollments: '/crm/journey/automation/:automationId',
    crmAccountDetail: '/crm/accounts/:id',
    crmContacts: '/crm/contacts',
    crmContactsImport: '/crm/contacts/import',
    crmContactDetail: '/crm/contacts/:id',
    crmTasks: '/crm/tasks',
    crmAutomations: '/crm/automations',
    crmReporting: '/crm/reporting',
    crmForms: '/crm/forms',
    crmEmailTemplates: '/crm/email-templates',
    crmContractTemplates: '/crm/contract-templates',
    crmAudiences: '/crm/audiences',
    crmCampaigns: '/crm/campaigns',
    crmImport: '/crm/import',
    crmSettings: '/crm/settings',
    crmCalendarSettings: '/crm/calendar-settings',
    crmMeetings: '/crm/meetings',
    imageAssets: '/communications/image-assets',
    businessDeletionRequests: '/businesses/deletion-requests',
    brandedAppRequests: '/businesses/branded-app-requests',
    brandedAppRequestDetail: '/businesses/branded-app-requests/:businessId',
    crmDuplicates: '/businesses/duplicates',
    businessOnboarding: '/businesses/onboarding',
    inviteBusiness: '/businesses/invite',
    pageEdit: '/page-management/edit/:id',
    pageList: '/page-management/list',
    integrationCardList: '/integration-cards/list',
    integrationCardAdd: '/integration-cards/add',
    integrationCardEdit: '/integration-cards/edit/:id',
    reportingBusinesses: '/reporting/businesses',
    reportingSalesReport: '/reporting/sales-report',
    reportingUnsubscribed: '/reporting/businesses/unsubscribed',
    reportingCommunicationReports: '/reporting/communication-reports',
    reportingOnboarding: '/reporting/onboarding',
    login: '/login',
    onboardingTemplates: '/settings/onboarding-templates',
    onboardingQuestionnaire: '/settings/onboarding-questionnaire',
    trainingManualTemplate: '/settings/training-manual',
    queueMonitor: '/system/queue-monitor',
    queueMonitorDetail: '/system/queue-monitor/:queueName',
    featureFlags: '/system/feature-flags',
    emailDeliverability: '/system/email-deliverability'
};
export default ERoutes;
